import { categories, siteInfo } from "@/mocks/comics";

const navLinks = [
  { label: "人气榜单", href: "#ranking" },
  { label: "热门精选", href: "#featured" },
  { label: "题材分类", href: "#categories" },
  { label: "新作速递", href: "#new" },
  { label: "关于漫潮", href: "#about" },
  { label: "联系我们", href: "#contact" },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/70 border-t border-background-300/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* brand */}
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 font-display text-2xl">
                漫
              </span>
              <span className="font-display text-2xl text-foreground-950">
                漫潮<span className="text-accent-600">精选榜</span>
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mt-4">
              专注韩国动态漫画推荐与排行，人气榜单实时更新，精选高口碑作品，帮你快速锁定心仪韩漫，追更不迷路。
            </p>
            <div className="flex items-center gap-2 mt-5">
              {["ri-weibo-line", "ri-bilibili-line", "ri-tiktok-line", "ri-mail-line"].map((icon) => (
                <a
                  key={icon}
                  href="#contact"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50 border border-background-300 text-foreground-600 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-colors cursor-pointer"
                >
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* nav */}
          <nav aria-label="栏目导航">
            <h4 className="text-sm font-black text-foreground-950 mb-4">栏目导航</h4>
            <ul className="space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* categories */}
          <div>
            <h4 className="text-sm font-black text-foreground-950 mb-4">热门题材</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((c) => (
                <li key={c.name}>
                  <a href="#categories" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* contact */}
          <div>
            <h4 className="text-sm font-black text-foreground-950 mb-4">联系方式</h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                <a href={`mailto:${siteInfo.contactEmail}`} className="hover:text-primary-600">
                  {siteInfo.contactEmail}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-global-line text-primary-500"></i>
                榜单每周一更新
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-refresh-line text-primary-500"></i>
                分类与专题持续扩充
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {siteInfo.brand} · {siteInfo.slogan}，本站仅提供推荐与索引，作品版权归原作者所有。
          </p>
          <a href="#top" className="inline-flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-600 whitespace-nowrap">
            回到顶部 <i className="ri-arrow-up-line"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}